export default __webpack_public_path__ + "static/media/waiting_for_accept_active.946c0785.svg";